<template>
	<v-row 
		:align="$vuetify.breakpoint.smAndDown ? 'center' : 'start'" 
		justify="center"
	>
		<v-col md="2" sm="12" :class="{ 'h-600': $vuetify.breakpoint.mdAndUp }">
			<v-navigation-drawer
				permanent
				class="d-flex flex-column justify-space-between h-100"
				style="width: 100%; box-shadow: none"
			>
				<div 
					:class="{ 'text-center d-flex justify-center align-center': $vuetify.breakpoint.smAndDown }"
					class="ml-2"
				>
					<v-chip class="green lighten-5 green--text" x-small> 
						33%
					</v-chip>
			
					<!-- <p class="font-weight-light text-body-2 mb-0">{{ versions.length }} Versions</p> -->
					<div 
						class="mt-3"
					>
						<v-btn-toggle
							v-model="isArchived"
							mandatory
							dense
							class="rounded-lg"
							active-class="green accent-3"
						>
							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										@click="filterArchivedOrUnAr()"
										icon
										v-bind="attrs" 
										v-on="on"
									>
										<v-icon small> mdi-treasure-chest </v-icon>
									</v-btn>
								</template>
								<span>Saved </span>
							</v-tooltip>

							<v-tooltip right>
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										@click="filterArchivedOrUnAr()"
										icon
										v-bind="attrs" 
										v-on="on"
									> 
										<v-icon small> mdi-archive-outline </v-icon> 
									</v-btn>
								</template>
								<span>Archived</span>
							</v-tooltip>
						</v-btn-toggle>
					</div>
				</div>

				<div 
					class="mt-3"
					:class="{ 'd-flex justify-space-between': $vuetify.breakpoint.smAndDown }"
					style="height: 75%"
				>
					<div
						v-for="(version, i) in versions"
						:key="i"
						:class="{
							'edit-color--text': selectedVersion === version
						}"
						class="py-2"
						text
						elevation="0"
						@click="selectedVersion = version"
					>
						<div class="d-flex">
							<div>
								<v-icon
									left
									:class="{ 'edit-color--text': selectedVersion === version }"
								>
									mdi-chevron-right
								</v-icon>
								<!-- V{{ version.name }} -->
								<v-chip color="primary mr-4" x-small>
									<!-- {{ version.number }} -->
								</v-chip>
							</div>
						</div>
						
						<div> 
							<div class="ml-6">
								<!-- <v-chip color="green lighten-5 green--text" x-small>{{ version.active }} active</v-chip>  -->
							</div>
							<div class="ml-6">
								<!-- <v-chip color="light-blue lighten-5 blue--text" x-small>{{ version.finished }} finished</v-chip>  -->
							</div>
						</div>
					</div>
				</div>
				<!-- The button of the feature's dialog -->
				<v-btn
					@click="versionDialog = true"
					:class="{ 'w-100': $vuetify.breakpoint.smAndDown }"
					class="text-none rounded-lg"
					color="white--text green accent-4"
					depressed
					small
					:disabled="loading"
				>
					<v-icon left >mdi-plus</v-icon>
					Add Version
				</v-btn>

				<v-dialog
					v-model="versionDialog"
					max-width="400px"
				>
					<v-card>
						<v-card-title class="mb-1">
							<span class="">Add new version</span>
						</v-card-title>
						<v-card-text>
							<v-form ref="form">
								<!-- <div> -->
								<h3 class="pb-2">Contract:</h3>
								<v-row class="mb-1 mt-1">
									<v-col cols="6" class="pt-0">
										<v-text-field
											v-model="version.name"
											solo
											dense
											hide-details
											label="Version"
											required
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
											class="input"
										></v-text-field>
									</v-col>
									<v-col cols="6" class="pt-0">
										<bee-date-picker
											v-model="version.contractDate" 
											input-label="Date"
											elevation="2"
											menu-picker
											hide-details
											:input-props="{
												dense: true,
												clearable: false,
											}"
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
										></bee-date-picker>
									</v-col>
								</v-row>
								<!-- </div> -->
							
								<!-- Arrange number fields in the same row -->
								<!-- <div> -->
								<h3 class="pb-2">Contract Time:</h3>
								<v-row class="mt-1">
									<v-col cols="6" class="pt-0">
										<bee-date-picker
											v-model="version.startDate" 
											input-label="Start Date"
											elevation="2"
											menu-picker
											hide-details
											:input-props="{
												dense: true,
												clearable: false,
											}"
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
											solo
										></bee-date-picker>
									</v-col>
									<v-col cols="6" class="pt-0">
										<bee-date-picker
											v-model="version.endDate" 
											input-label="End Date"
											elevation="2"
											menu-picker
											hide-details
											:input-props="{
												dense: true,
												clearable: false,
											}"
											:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
											solo
										></bee-date-picker>
									</v-col>
								</v-row>
								<!-- </div> -->
							</v-form>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="success " class="text-none" @click="addVersion()">Save</v-btn>
							<v-btn
								@click="versionDialog = false"
								color="alert-color white--text"
								class="text-none"
							>
								Cancel
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>	
			</v-navigation-drawer>
		</v-col>
		<v-col md="10" sm="12" class="pl-2 w-100 py-0">
			<!-- filter -->
			<v-row class="mt-3" align="center">
				<v-col md="2" sm="3" class="pa-1">
					<v-text-field
						v-model="feature"
						dense
						solo
						label="Feature"
						class="input"
						hide-details
						clearable
						:disabled="loading"
						:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					></v-text-field>
				</v-col>

				<v-col md="3" sm="4" class="pa-1">
					<v-autocomplete
						v-model="selectedPerson"
						:items="usersWithoutPag"
						:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
						item-value="id"
						multiple
						dense
						solo
						class="input"
						label="Employees"
						hide-details
						clearable
						:disabled="loading"
					>
						<template v-slot:selection="{ item, index }">
							<div class="d-flex align-center">
								<div v-if="index === 0">
									<span>{{ item.employee.arabicFirstName + ' ' + item.employee.arabicLastName }}</span>
								</div>
								<span v-if="index === 1" class="ml-2"> 
									(+{{ selectedPerson.length - 1 }} others) 
								</span>
							</div>
							
						</template>
					</v-autocomplete>
				</v-col>

				<v-col cols="auto" class="pa-1">
					<div class="d-flex flex-column">
						<span class="text-body-2 font-weight-medium">Type</span>
						<v-radio-group row dense class="ma-0 pt-0" hide-details v-model="selectedType">
							<!-- <v-radio
								v-for="(type, index) in typeFeatures"
								:key="index"
								:label="type.name"
								:value="type.id"
								:disabled="loading"
							></v-radio> -->
						</v-radio-group>
					</div>
				</v-col>
				<v-spacer />
				<div class="d-flex">
					<v-btn
						class="dark-blue text-capitalize white--text mx-1"
						@click="needToResetShownRows = true; getAll()"
						:disabled="loading"
					>
						Search
					</v-btn>
					<v-btn
						class="error text-capitalize white--text mx-1"
						:disabled="loading"
						@click="resetFields"
					>
						Reset
					</v-btn>
				</div>
			</v-row>
			<section>
				<v-card
					:style="!$vuetify.theme.dark ? '' : null" 
					class=" rounded-lg mt-6"
					:class="{
						'box': !$vuetify.theme.dark
					}"
				>
					<v-card-text class="d-flex align-center">
						<v-row>
							<v-col cols="4" md="auto" >
								<div class="d-flex justify-center ml-2 mr-1">
									<div class="d-flex justify-center align-center">
										<v-img
											src="../../assets/Features/document-signed 1.svg"
											width="20"
										/>
									</div>
									<div class="d-flex flex-column mx-3">
										<span class="font-weight-light text-body-2">Contract Date</span>
										<span class="text-color--text text-body-2" >16 jun, 2023</span>
									</div>
								</div>
							</v-col>

							<v-col cols="4"  md="auto">
								<div class="d-flex justify-center ml-2 mr-1">
									<div class="d-flex justify-center align-center">
										<v-img
											src="../../assets/Features/hourglass-start.svg"
											width="20"
										/>
									</div>
									<div class="d-flex flex-column mx-3">
										<span class="font-weight-light text-body-2">Start Date</span>
										<span class="text-color--text text-body-2">23 Aug, 2023</span>
									</div>
								</div>
							</v-col>

							<v-col cols="4"  md="auto">
								<div class="d-flex justify-center ml-2 mr-1">
									<div class="d-flex justify-center align-center">
										<v-img
											src="../../assets/Features/hourglass-end.svg"
											width="20"
										/>
									</div>
									<div class="d-flex flex-column mx-3">
										<span class="font-weight-light text-body-2">End Date</span>
										<span class="text-color--text text-body-2" >15 Apr, 2024</span>
									</div>
								</div>
							</v-col>
							
							<v-col 
								class="d-flex mb-1" 
								:class="{ 
									'justify-center': $vuetify.breakpoint.smAndDown,
									'justify-end': $vuetify.breakpoint.mdAndUp
								}"
							>
								<v-card text class="d-flex align-center px-4 red--text red lighten-5">
									<v-icon color="red" size="18" class="pr-2">mdi-alert</v-icon>
									<span>23 days left</span>
								</v-card>

								<v-btn 
									depressed 
									class="green accent-4 d-flex mr-1 text-none white--text mx-3" 
									@click="featureDialog = true"
									:disabled="loading"
								>
									<v-icon left class="white--text">mdi-plus</v-icon>
									Add Feature
								</v-btn>
								<!-- Feature's dialog -->
								<v-dialog
									v-model="featureDialog"
									max-width="450px"
								>
									<v-card>
										<v-card-title class="mb-2 d-flex">
											<span class="headline">Add new feature</span>
											<v-spacer></v-spacer>
											<div class="text-body-2">
												<!-- <span>Current Version: {{ selectedVersion.name }}</span> -->
											</div>
										</v-card-title>
										<v-card-text>
											<v-form ref="form">
												<v-row class="mt-2">
													<v-col cols="12" class="d-flex py-2">
														<span class="text-body-2 font-weight-medium mr-3">Type:</span>
														<v-radio-group
															v-model="dataDialog.type"
															row
															dense
															class="ma-0 pt-0"
															hide-details
															:disabled="submitLoading"
														>
															<v-radio
																v-for="(type, index) in typeFeatures"
																:key="index"
																:label="type.name"
																:value="type.id"
																dense
															></v-radio>
														</v-radio-group>
													</v-col>

													<v-col cols="12" class="py-2">
														<v-text-field
															v-model="dataDialog.title"
															solo
															dense
															hide-details
															label="Feature"
															required
															:loading="submitLoading"
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															class="input"
														></v-text-field>	
													</v-col>

													<v-col cols="" class="py-2">
														<v-autocomplete
															v-model="dataDialog.contributorsIds"
															:items="usersWithoutPag"
															:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
															item-value="id"
															dense
															label="Employees"
															solo
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															hide-details
															multiple
															:loading="submitLoading"
															class="input"
														>

															<template v-slot:selection="{ item, index }">
																<span v-if="index === 0" class="me-1">
																	{{
																		item.employee.arabicFirstName + ' ' +item.employee.arabicLastName 
																	}}
																</span>
																<span
																	v-if="index === 1"
																	class="text--color text-caption"
																>
																	(+{{ dataDialog.contributorsIds.length - 1 }})
																</span>
															</template>
														</v-autocomplete>
													</v-col>

													<v-col cols="6" class="py-2">
														<bee-date-picker
															v-model="dataDialog.startDate" 
															input-label="Start Date"
															elevation="2"
															menu-picker
															hide-details
															:input-props="{
																dense: true,
																clearable: false,
															}"
															:loading="submitLoading"
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															class="input"
														></bee-date-picker>
													</v-col>
													
													<v-col cols="6" class="py-2">
														<bee-date-picker
															v-model="dataDialog.endDate" 
															input-label="End Date"
															elevation="2"
															menu-picker
															hide-details
															:input-props="{
																dense: true,
																clearable: false,
															}"
															:loading="submitLoading"
															months-over-max="2"
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															class="input"
														></bee-date-picker>
													</v-col>

													<v-col cols="6" class="py-2">
														<v-text-field
															v-model="dataDialog.estimatedTime"
															label="Estimated Time"
															type="number"
															min="0"
															solo
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															dense
															hide-details
															required
															:loading="submitLoading"
															class="input"
														></v-text-field>
													</v-col>

													<!-- <v-col cols="6" class="py-2">
														<bee-date-picker
															v-model="deliveryDateF" 
															input-label="Date"
															elevation="2"
															menu-picker
															hide-details
															:input-props="{
																outlined: true,
																dense: true,
																clearable: false,
															}"
														></bee-date-picker>
													</v-col> -->
												
													<v-col cols="12" class="py-2">
														<v-text-field
															v-model="dataDialog.notes"
															label="Notes"
															solo
															:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
															dense
															hide-details
															required
															:loading="submitLoading"
															class="input"
														></v-text-field>
													</v-col>
												</v-row>
											</v-form>
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn 
												@click="AddFeatures()"
												color="success white--text" 
												class="rounded-lg text-none" 
											>
												Save
											</v-btn>
											<v-btn 
												@click="featureDialog = false"
												color="alert-color white--text"
												class="rounded-lg text-none" 
											>
												Cancel
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</section>
			<section>
				<div class="mt-6">
					<bee-handy-table
						ref="table"
						:headers="headers"
						hide-default-footer
						dense
						:items="[]"
						item-value="id"
						item-class="px-0"
						:options-scroll.sync="optionsScroll"
						pagination-on-scroll
						pagination-on-scroll-server-items
						:pagination-on-scroll-auto-reset-shown="false"
						:server-items-length="serverItemsLength"
						@pagination-on-scroll:reach-last-row="getAll"
						:loading="loading"
						elevation="0"
						:data-table-props="{
							singleExpand: true,
							expandedSync: expanded,
							showExpand: true,
							itemKey: 'id',
							disableSort: true
						}"
						zebra
					>
						<!-- Items Templates -->
						<template v-slot:item.feature="{ item }">
							<!-- <div class="d-flex"> -->
								<!-- <div class="d-flex align-center pr-4">
									<v-img
										:src="require(`@/assets/Features/${item.typeImage}`)"
										max-height="25"
										max-width="25"
									></v-img>
								</div> -->
								<!-- <div class="w-100"> -->
									<div class="d-flex">
										<v-avatar
											:color="item.status === 'working' ? 'orange' : item.status === 'paused' ? 'red' : 'blue'"
											size="8"
											class="my-auto mr-2"
										>
										</v-avatar>
										<div>{{ item.title }}</div>
									</div>
									<div class="d-flex">
										<v-progress-linear
											:value="item.inProgress"
											height="6"
											background-color="grey darken-2"
											:color="item.status === 'working' ? 'orange' : item.status === 'paused' ? 'red' : 'blue'"
											class="mt-2 rounded"
										></v-progress-linear>
										<div class="px-2">{{ item.inProgress }}%</div>
									</div>
								<!-- </div> -->
							<!-- </div> -->
						</template>

						<template v-slot:item.date="{ item }">
							<div class="d-flex flex-column">
								<div>
									<v-avatar size="8" color="green" class="mr-1"></v-avatar>
									{{ 
										item.startDate ? moment(item.startDate).format('d MMM, YYYY') : 'no start date' 
									}}
								</div>
								<div>
									<v-avatar size="8" color="red" class="mr-1"></v-avatar>
									{{ 
										item.endDate ?  moment(item.endDate).format('d MMM, YYYY') : 'no end date' 
									}}
								</div>
							</div>
						</template>
						<!-- <template v-slot:[`item.notes`]="{ item }">
							<div class="d-flex align-center">
								<p class="text-cation font-wieght-light mb-0">{{ item.notes }}</p>
							</div>
						</template> -->
						<!-- <template v-slot:item.contributers>
							<div class="d-flex"> 
								<v-img :src="require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg')" max-height="30" max-width="30" class="mr-n2"></v-img> 
								<v-img :src="require('@/assets/Features/cropped-Profile-Picture-Round-Color.svg')" max-height="30" max-width="30" class="mr-n2"></v-img> 
								<v-img :src="require('@/assets/Features/Tyson-Andrus.svg')" max-height="30" max-width="30"> </v-img>
							</div> 
						</template> -->
						<!-- <template v-slot:[`item.date`]="{ item }">
							<div class="d-flex align-start">
								<span class="text-caption font-weight-light">
									<v-avatar size="8" color="green" class="mr-1"></v-avatar>
									{{ item.date.start }}
								</span>
							</div>
							<div class="d-flex align-start mt-1">
								
								<span class="text-caption font-weight-light">
									<v-avatar size="8" color="red" class="mr-1"></v-avatar>
									{{ item.date.end }}
								</span>
							</div>
						</template> -->
						<!-- <template v-slot:[`item.funtional`]="{ item }">
							<div v-if="item.funtional === 'checkbox'"> 
								<v-checkbox v-model="isChecked" disabled></v-checkbox> 
							</div>
							<div v-else> {{ item.funtional }} </div>
						</template> -->
				
						<!-- Adding expanded-item slot --> 
						<template v-slot:expanded-item="{ headers, item }">
							<td :colspan="headers.length" class="pa-0">
								<div> 
									<bee-handy-table
										:headers="subHeaders"
										:items="item.plannedTasks"
										hide-default-footer
										dense
										class="rounded-0"
									>

										<!-- <template v-slot:[`item.feature`]="{ item }">
											<div class="d-flex">
												<v-avatar :color="item.funtional === 'checkbox' ? 'yellow' : 'green'" size="8" class="my-auto ml-1 mr-2"></v-avatar>
												<div class="d-flex align-center pr-3 pl-1">
													<v-img :src="require(`@/assets/Features/${item.typeImage}`)" max-width="20"></v-img> 
												</div>
												<span>{{ item.feature }}</span>
											</div>
										</template>
										<template v-slot:[`item.contributers`]="{ item }">
											<div class="d-flex">
												<v-img
												v-for="(image, index) in item.contributers"
												:key="index"
												:src="image.image"
												max-width="28"
												max-height="28"
												class="mr-n2"
												></v-img>
											</div>
										</template>
										<template v-slot:[`item.date`]="{ item }">
											<div class="d-flex align-start">
												
												<span class="text-caption font-weight-light">
													<v-avatar size="8" color="green" class="mr-1 mb-1"></v-avatar>
													{{ item.date.start }}
												</span>
											</div>
											<div class="d-flex align-start mt-1">
												<span class="text-caption font-weight-light">
													<v-avatar size="8" color="red" class="mr-1 mb-1"></v-avatar>
													{{ item.date.end }}
												</span>
											</div>
										</template>
										<template v-slot:[`item.priority`]="{ item }">
											<div>
												<v-chip 
												x-small 
												:class="{ 
													'red lighten-5 red--text': item.priority === 'Low', 
													'light-blue lighten-5 blue--text': item.priority === 'Normal', 
													'purple lighten-5 purple--text': item.priority === 'Hight' 
													}"
												>
													{{ item.priority }}
												</v-chip>
											</div>
										</template>
										
										<template v-slot:[`item.funtional`]="{ item }">
											<div v-if="item.funtional.type === 'checkbox'"> 
												<v-checkbox dense v-model="item.funtional.model" hide-details class="py-auto"></v-checkbox> 
											</div>
											<div v-else> {{ item.funtional }} </div>
										</template>

										<template v-slot:[`item.acceptance`]>
											<div> 
												<v-checkbox dense hide-details class="py-auto"></v-checkbox> 
											</div>
										</template>
										
										<template v-slot:[`item.deliveryT`]="{ item }">
											<div class="d-flex justify-center align-center">
												<v-img
													:src="require(`@/assets/Features/${item.deliveryT}`)"
													max-height="18"
													max-width="18"
												></v-img>
											</div>
										</template>  -->
										<template v-slot:item.date="{ item }">
											<div class="d-flex align-start">
												<span class="text-caption font-weight-light">
													<v-avatar size="8" color="green" class="mr-1 mb-1"></v-avatar>
													{{ item.start ? item.start : '-' }}
												</span>
											</div>
											<div class="d-flex align-start mt-1">
												<span class="text-caption font-weight-light">
													<v-avatar size="8" color="red" class="mr-1 mb-1"></v-avatar>
													{{ item.end ? item.end : '-' }}
												</span>
											</div>
										</template>
									</bee-handy-table> 
								</div>
							</td>
						</template>
					</bee-handy-table>
				</div>
			</section>
		</v-col>
	</v-row>
</template>
<script>
import { typeFeatures } from '@/helper/enum'
import { mapState } from 'vuex';
import moment from 'moment';
export default {
	data () {
		return {
			feature: '',
			selectedPerson: [],
			isArchived: 0,
			selectedType: 2,
			featureDialog: false, 
			plansF: '', 
			actualTimeF: '',
			deliveryDateF: '', 
			notesF: '',
			isChecked: true,
			versionDialog: false,
		
			expanded: [], 
			singleExpand: false,
			selectedVersion: {},
			// versions: [
			// 	{ name: '1.0.0', active: 5, finished: 20, number: '25' },
			// 	{ name: '1.0.1', active: 1, finished: 5, number: '30' },
			// 	{ name: '1.1.0', active: 1, finished: 2, number: '18' },
			// 	{ name: '2.2.0', active: 0, finished: 0, number: '20' }
			// ],
			versions: [],
			headers: [
				{
					text: 'Feature',
					name: 'feature',
					value: '',
					align: 'start',
					sortable: false,
					width: '250px', 
					class: 'pr-2 pl-1',
					cellClass: 'pr-2 pl-1'
				},
				{
					text: 'Contributors',
					name: 'contributors',
					value: 'contributorsIds',
					setValueExpr: val => val.length ? val.map(c => this.usersWithoutPag.find(c => c.id === val)?.name) : '-',
					sortable: false,
					width: '60px', 
					class: 'pl-2 pr-0',
					cellClass: 'pl-2 pr-0'
				},
				{
					text: 'Date',
					name: 'date',
					value: '',
					width: '150px', 
					class: 'px-2',
					cellClass: 'px-2',
					sortable: false
				},
				{
					text: 'C.Time',
					sortable: false,
					value: 'contract',
					width: '40px', 
					class: 'px-1',
					cellClass: 'px-1' 
				},
				{
					text: 'Plans',
					value: 'planHours',
					name: 'planHours',
					width: '40px', 
					class: 'pr-2 pl-1',
					cellClass: 'pr-2 pl-1',
					sortable: false
				},
				{
					text: 'Actuall',
					value: 'realTime',
					name: 'realTime',
					sortable: false,
					width: '40px', 
					class: 'px-1',
					cellClass: 'px-1'
				},
				{
					text: 'Delivery',
					name: 'endDate',
					value: 'endDate',
					setValueExpr: val => val ? moment(val).format('YYYY-MM-DD') : '-',
					width: '95px', 
					class: 'px-1',
					cellClass: 'px-1',
					sortable: false
				},
				{
					text: 'Notes',
					sortable: false,
					value: 'notes',
					width: '125px', 
					class: 'px-2',
					cellClass: 'px-2'
				},
				{
					text: 'Funtional',
					sortable: false,
					value: 'funtional',
					width: '30px', 
					class: 'px-2',
					cellClass: 'px-2'
				},
				{
					text: '',
					align: 'end',
					sortable: false,
					value: 'deliveryT',
					width: '35px', 
					class: 'px-2 aign',
					cellClass: 'pl-1 pr-4'
				}
			],
			items: [
				{
					id: 1,
					feature: {
						title: 'Visitor and customer pages within the site and applications',
						progress: 63,
						status: 'working'
					},
					typeImage: 'document-signed 2.svg',
					notes: 'Lorem ipsum dolor sit amet. Lorem ipsum dolor',
					contributers: '',
					date: { start: '13 Aug, 2023', end: 'no end date' },
					contract: '156 H',
					plan: '166 H',
					time: '98 H',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				},
				{
					id: 2,
					feature: {
						title: 'User Notifications',
						progress: 23,
						status: 'working'
					},
					typeImage: 'document-signed 2.svg',
					notes: 'Lorem ipsum dolor sit amet. Lorem ipsum dolor',
					contributers: '',
					date: { start: '13 Aug, 2023', end: 'no end date' },
					contract: '156 H',
					plan: '166 H',
					time: '98 H',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				},
				{
					id: 3,
					feature: {
						title: 'Manage custom specifications by categories',
						progress: 42,
						status: 'working'
					},
					typeImage: 'document-signed 2.svg',
					notes: 'Lorem ipsum dolor sit',
					contributers: '',
					date: { start: '13 Aug, 2023', end: 'no end date' },
					contract: '156 H',
					plan: '166 H',
					time: '98 H',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				},
				{
					id: 4,
					feature: {
						title: 'Automated messaging feature',
						progress: 18,
						status: 'paused'
					},
					typeImage: 'user-headset 1.svg',
					notes: 'Lorem ipsum dolor sit',
					contributers: '',
					date: { start: '13 Aug, 2023', end: '2 Feb, 2024' },
					contract: '156 H',
					plan: '166 H',
					time: '98 H',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				},
				{
					id: 5,
					feature: {
						title: 'Account Verification Service',
						progress: 0,
						status: 'new'
					},
					typeImage: 'document-signed 2.svg',
					notes: 'Lorem ipsum dolor sit',
					contributers: '',
					date: { start: '13 Aug, 2023', end: '2 Feb, 2024' },
					contract: '156 H',
					plan: '166 H',
					time: '-',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				},
				{
					id: 6,
					feature: {
						title: 'Link to elecotronic payment',
						progress: 0,
						status: 'new'
					},
					typeImage: 'document-signed 2.svg',
					notes: 'Lorem ipsum dolor sit',
					contributers: '',
					date: { start: '13 Aug, 2023', end: '2 Feb, 2024' },
					contract: '156 H',
					plan: '166 H',
					time: '-',
					deliveryD: '10-10-2024',
					funtional: 'checkbox',
					deliveryT: 'eye (2) 1.svg'
				}
			],
			subHeaders: [
				{
					text: 'Feature',
					value: 'content',
					width: '185px',
					class: 'px-3',
					sortable: false,
					align: 'start',
					cellClass: 'px-2'
				},
				{
					text: 'Contributers',
					sortable: false,
					value: 'contributers',
					width: '70px',
					class: 'px-2',
					cellClass: 'px-2' 
				},
				{
					text: 'Date',
					name: 'date',
					value: 'date',
					width: '100px',
					class: 'px-2',
					sortable: false,
					cellClass: 'px-2' 
				},
				{
					text: 'Priority',
					sortable: false,
					value: 'priority',
					width: '45px',
					class: 'px-2',
					cellClass: 'px-2'
				},
				{
					text: 'C.Time',
					sortable: false,
					value: 'contract',
					width: '40px',
					class: 'px-1',
					cellClass: 'px-1'
				},
				{
					text: 'Plans',
					sortable: false,
					value: 'plan',
					width: '40px',
					class: 'px-1',
					cellClass: 'px-1' 
				},
				{
					text: 'Actuall',
					sortable: false,
					value: 'time',
					width: '40px',
					class: 'px-1',
					cellClass: 'px-1'
				},
				{
					text: 'Delivery',
					sortable: false,
					value: 'deliveryD',
					width: '70px',
					class: 'px-2',
					cellClass: 'px-2' 
				},
				{
					text: 'Terms',
					sortable: false,
					value: 'terms',
					width: '85px',
					class: 'px-2',
					cellClass: 'px-2' 
				},
				{
					text: 'A',
					sortable: false,
					value: 'funtional',
					width: '25px',
					class: 'pl-2',
					cellClass: 'px-0'
				},
				{
					text: 'F',
					sortable: false,
					value: 'acceptance',
					width: '25px',
					class: 'pl-2',
					cellClass: 'px-0'
				},
				{
					text: '',
					align: 'end',
					sortable: false,
					value: 'deliveryT',
					width: '35px',
					class: 'px-2',
					cellClass: 'px-2'
				}
			], 
			nestedItems: { 
				1: [
					{
						id: 1,
						feature: 'Home Page',
						typeImage: 'document-signed 2.svg',
						terms: 'Lorem ipsum dolor sit amet',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') },
							{ image: require('@/assets/Features/cropped-Profile-Picture-Round-Color.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Low',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 2,
						feature: 'Category/Categories page',
						typeImage: 'document-signed 2.svg',
						terms: 'Lorem ipsum dolor sit amet',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') },
							{ image: require('@/assets/Features/cropped-Profile-Picture-Round-Color.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Normal',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 3,
						feature: 'Subscriptons and payments page',
						typeImage: 'document-signed 2.svg',
						terms: 'Lorem ipsum dolor sit amet',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Normal',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 4,
						feature: 'Exchange request/purchase request page',
						typeImage: 'document-signed 2.svg',
						terms: '-',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Normal',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 5,
						feature: 'Create membership page',
						typeImage: 'user-headset 1.svg',
						terms: '-',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') },
							{ image: require('@/assets/Features/cropped-Profile-Picture-Round-Color.svg') },
							{ image: require('@/assets/Features/Tyson-Andrus.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Normal',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 6,
						feature: 'Terms and conditions page',
						typeImage: 'user-headset 1.svg',
						terms: '-',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Hight',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					},
					{
						id: 7,
						feature: 'Submit a complaintn or request assistance page',
						typeImage: 'document-signed 2.svg',
						terms: 'Lorem ipsum dolor sit amet',
						contributers: [
							{ image: require('@/assets/Features/Beeri-round-profile-pic-e1466524893279.svg') }
						],
						date: { start: '13 Aug, 2023', end: '30 Dec, 2023' },
						priority: 'Normal',
						contract: '156 H',
						plan: '166 H',
						time: '98 H',
						deliveryD: '10-10-2024',
						funtional: {
							type: 'checkbox',
							model: false
						},
						acceptance: 'checkbox',
						deliveryT: 'eye (3) 1.svg'
					}
				] 
			},
			typeFeatures,
			needToResetShownRows: false,
			optionsScroll: {},
			serverItemsLength: 0,
			type: 0,
			dataDialog: {
				type: 0,
				title: null,
				startDate: null,
				endDate: null,
				estimatedTime: null,
				notes: null,
				contributorsIds: []
			},
			submitLoading: false,
			loading: false,
			version: {
				name: null,
				contractDate: null,
				startDate: null,
				endDate: null
			}
		}
	},

	watch: {
		versionDialog (val) {
			if (!val) {
				this.version.name = null 
				this.version.contractDate = null
				this.version.startDate = null
				this.version.endDate = null
			}
		}
	},

	computed: {
		...mapState({
			usersWithoutPag: state => state.users.usersWithoutPag
		})
	},

	methods: {  
		moment,
		getNestedItems (itemId) { 
			return this.nestedItems[itemId] || [];
		},
		AddFeatures () {
			this.submitLoading = true
			this.$store.dispatch('features/create', { 
				title: this.dataDialog.title,
				type: this.dataDialog.type,
				notes: this.dataDialog.notes,
				startDate: this.dataDialog.startDate,
				endDate: this.dataDialog.endDate,
				estimatedTime: this.dataDialog.estimatedTime,
				contributorsIds: this.dataDialog.contributorsIds
				// planHours, realTime, isDone, versionId, actualDeliveryDate, plannedTaskIds, taskIds
				// contractF deliveryDateF notesF
			}).then(() => {
				this.getAll()
			}).finally(() => {
				this.submitLoading = false
				this.featureDialog = false
			})
		},
		getAllActiveVersions () {
			this.loading = true
			this.$store.dispatch('projectVersion/fetchByProjectId', { 
				projectId: this.$route.params.id,
				isActive: this.isArchived 
			}).then((data) => {
				this.versions = data
			}).finally(() => {
				this.loading = false
			})
		},
		addVersion () {
			this.submitLoading = true
			this.$store.dispatch('projectVersion/create', { 
				name: this.version.name, 
				contractDate: this.version.contractDate,
				startDate: this.version.startDate, 
				endDate: this.version.endDate,
				projectId: this.$route.params.id,
				isArchived: true,
				isActive: true
			}).then(() => {
				this.versionDialog = false
				this.getAllActiveVersions()
			}).finally(() => {
				this.submitLoading = false
			})
		},
		resetFields () {
			this.feature = '';
			this.selectedPerson = [];
			this.selectedType = 2;
		},

		getAll (newOptionsScroll) {
			this.loading = true
			let page = 1
			if (newOptionsScroll) {
				page = newOptionsScroll.page
			}
			return this.$store.dispatch('features/fetchAll', {
				// versionId,
				employeeId: this.selectedPerson,
				type: this.selectedType === 2 ? null : this.selectedType,
				featureName: this.feature,
				isArchived: Boolean(!this.isArchived),
				// fromDate, toDate, contractDate, orderByDate, 
				page: page,
				perPage: 20
			}).then(({ data, total }) => {
				if (this.needToResetShownRows === true) {
					this.$refs.table.resetShownRows()
				}
				console.log(data)
				this.$refs.table.addScrollItems(data)
				this.serverItemsLength = total;
			}).finally(() => {
				this.loading = false
				this.needToResetShownRows = false
			})
		},

		filterArchivedOrUnAr () {}
	},
	created () { 
		this.selectedVersion = this.versions[this.versions.length - 1]; 
		this.needToResetShownRows = true
		this.getAll()
		this.getAllActiveVersions()
		this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true })
		this.$store.dispatch('projectVersion/fetchProjectVersions', { isArchived: Boolean(this.isArchived) }).then((data) => {
			this.versions = data
		})
	}
}
</script>
<style scoped>
.h-600 {
	height: 600px
}
</style>
